export default {
  required: 'Campo obrigatório',
  email: {
    invalid: '*Você inseriu um e-mail incorreto.\nApós 3 tentativas, sua conta será bloqueada.'
  }
}
